import React, { Fragment, useState, useEffect } from "react";
import { Card, Form, Spinner, Button } from "react-bootstrap";
import {  useLocation, useParams } from "react-router-dom";
import Snackbars from "../../../utils/Snackbars";
import useRequests from "../../../utils/useRequests";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";


const Transactions = () => {
  const location = useLocation();
  const { getRequest } = useRequests();

  const [transactions, setTransactions] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

 

  const [AlertData, setAlertData] = React.useState({
    variant: '',
    message: '',
  });

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: '',
        message: '',
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const [loading, setLoading] = useState(true);

  const fetchTransactions = async () => {
    const response = await getRequest(`transactions`); 
    if (response && response.code === 200) {
      console.log(response.data);
      setTransactions(response.data);
    } else {
      console.error("Failed to fetch users transactions:", response.message);

      
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: response.message,
      }));
    }
    resetAlertData();
    setLoading(false);
  };

  useEffect(() => {
    fetchTransactions();
    if (location.state && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
      setLoading(false);
    }
  }, []);

  // Filter users based on the search query
  const filteredTransactions = transactions.filter((transaction) => {
    const name = `${transaction.first_name} ${transaction.last_name}`.toLowerCase();
    const event = `${transaction.name}`.toLowerCase();
    const duration = `${transaction.duration} day`;
    const quantity = `${transaction.quantity}`;
    const type = `${transaction.type}`.toLowerCase();
    const price = `${transaction.price}`.toLowerCase();

    const date = new Date(transaction.created_at);
    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const formattedTime = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    });
    const transaction_date = `${formattedDate}`;
    const payment_id = `${transaction.payment_id}`.toLowerCase();

    const searchLower = searchQuery.toLowerCase();
  
    return quantity.includes(searchQuery) || name.includes(searchQuery) || price.includes(searchLower) || transaction_date.includes(searchQuery) || event.includes(searchLower) || duration.includes(searchLower) || type.includes(searchLower) || payment_id.includes(searchQuery);
  });




  const columns = [
    {
        name: "Full Name",
        selector: (row) => `${row.first_name +" "+ row.last_name}`,
        sortable: true,
        width: "200px" 
    },
    {
      name: "Event",
      selector: (row) => `${row.name}`,
      sortable: true,
      width: "150px" 
    },
    {
        name: "Duration",
        selector: (row) => `${row.duration} day`,
        sortable: true,
        width: "150px" 
    },
    {
      name: "Type",
      selector: (row) => row.type,
      sortable: true,
    },
    {
      name: "No. of Tickets",
      selector: (row) => `${row.quantity}`,
      sortable: true,
      width: "150px" 
    },
    {
      name: "Price",
      selector: (row) => row.price,
      sortable: true,
      width: "150px" 
    },
    {
      name: "Date",
      selector: (row) => {
        const date = new Date(row.created_at);
        const formattedDate = date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        const formattedTime = date.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return `${formattedDate}`;
      },
      sortable: true,
      width: "150px" 
    },
    {
      name: "Payment Id",
      selector: (row) => row.payment_id,
      sortable: true,
      width: "150px" 
    },
    
  ];

  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headCells: {
      style: {
        color: "#341439",
        fontSize: "17px",
        fontWeight: "600",
        paddingLeft: "8px", // Adjust padding
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        fontSize: "16px",
        padding: "12px 9px",
        color: "#7E7E7E",
      },
    },
    pagination: {
      style: {
        fontSize: "16px",
      },
    },
  };

  const csvHeaders = [
    { label: "Full Name", key: "fullName" },
    { label: "Event", key: "name" },
    { label: "Duration", key: "duration" },
    { label: "Type", key: "ticket_type" },
    { label: "No. of Tickets", key: "quantity" },
    { label: "Price", key: "price" },
    { label: "Date", key: "date" },
    { label: "Payment Id", key: "payment_id" },
];


const csvData = filteredTransactions.map((transaction) => {

  const formatDateTime = (date) => {
      if (!date) return "-";
      const d = new Date(date);
      return d.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
      });
    };

    return {
      fullName: `${transaction.first_name} ${transaction.last_name}`,
        name: transaction.name,
        duration: transaction.duration + " day",
        ticket_type: transaction.type,
        quantity: transaction.quantity,
        price: transaction.price,
        date: formatDateTime(transaction.created_at),
        payment_id: transaction.payment_id,
    };
  });

  return (
    <Fragment>
      <div className='d-sm-flex d-block justify-content-between align-items-center mb-4'>
        {AlertData.message !== "" ? (
          <Snackbars variant={AlertData.variant} message={AlertData.message} />
        ) : (
          ""
        )}
        <h2 className='text-black font-w600 mb-0'>Transaction</h2>
        <CSVLink data={csvData} headers={csvHeaders} filename={"transactions.csv"}>
                      <Button variant="primary">Download CSV</Button>
                  </CSVLink>
      </div>

      {/* Search input */}
      <div className='mb-4 d-sm-flex d-block justify-content-end'>
      <div style={{ position: "relative", width: "18rem" }}>
  <Form.Control
    type="text"
    placeholder="Search..."
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    style={{
      width: "100%",
      fontSize: "18px",
      fontWeight: 500,
      paddingRight: "2rem",
      borderRadius:'0.625rem',
      height:'3.2rem' // Add padding to ensure the icon doesn't overlap text
    }}
  />

  <i
    className="fa fa-search"
    style={{
      position: "absolute",
      right: "10px", // Distance from the right edge of the input
      top: "50%",
      transform: "translateY(-50%)", // Center vertically
      color: "#6c757d", // Optional: color for the icon
      pointerEvents: "none", // Makes sure clicks pass through to the input
    }}
  ></i>

</div>

      </div>

      <Card>
        <Card.Body>
          {loading ? (
                <div className='text-center'>
                  <Spinner animation='border' />
                  <p>Loading settings...</p>
                </div>) : 
          (<DataTable
            columns={columns}
            data={filteredTransactions} // Use filtered data
            customStyles={customStyles}
            pagination
            highlightOnHover
            responsive
          />)}
        </Card.Body>
      </Card>

    </Fragment>
  );
};

export default Transactions;
